var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"800998af3132160293c1e01451a900fda0aa87b0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["docupet-app-login@docupet"]={id:"800998af3132160293c1e01451a900fda0aa87b0"};
      